import { Component } from '@/types'
import { syncPreorderCartAttribute } from '@/utils/preorder-cart-attribute'

let listenersBound = false

const component: Component = () => {
  // Sync once on every hydration so the attribute is correct on first paint.
  syncPreorderCartAttribute()

  if (listenersBound) return
  listenersBound = true

  // After an add or any cart mutation, the server-rendered cart-validation-data
  // in the DOM is stale until refreshCartValidationData() in main-cart.ts
  // refetches it. Pass `refresh: true` so we read fresh data straight from
  // the cart page, not the local script tag.
  window.addEventListener('se-event.cart.product-added', () => {
    syncPreorderCartAttribute({ refresh: true })
  })

  window.addEventListener('se-event.cart.updated', () => {
    syncPreorderCartAttribute({ refresh: true })
  })
}

export default component
